import localforage from 'localforage'
import getAttributes from '../store/attributes'
import { actions as settingsActions } from '../features/Settings'
import { actions as steamActions } from '../features/Steam'
import { actions as toasterActions } from '../features/Toaster'
import { actions as usersActions } from '../features/Users'

// todo: attribs! take into account the language
//       this way we can have different local forage for the chinese version
export const forage = localforage.createInstance(getAttributes().localForage)

export class Forage {
    constructor() {
        try {
            this.forage = localforage.createInstance(getAttributes().localForage)
        } catch (error) {
            console.info(`Could not initialize localforage: ${error.message}`)
        }
    }

    // Read everything from localforage storage into state
    readIntoState(store) {
        this.readUsersIntoState(store)
        this.readUiSettingsIntoState(store)
        this.readMotdIntoState(store)
        this.readUsedSteamTicketIntoState(store)
    }

    // Read list of users into state
    readUsersIntoState(store) {
        if (this.forage !== undefined) {
            this.forage
                .getItem('users')
                .then((result) => {
                    if (result !== undefined && result !== null) {
                        store.dispatch(usersActions.setUsers(result))
                        window.setTokens()
                    } else {
                        console.info('No users were found in localforage')
                    }
                })
                .catch(error =>
                    console.info(`Could not read users from localforage: ${error.message}`),
                )
        } else {
            console.info('Forage could not be found, unable to read users')
        }
    }

    // Insert or update the users in localforage storage
    setUsers(users) {
        if (this.forage !== undefined) {
            // Save the new settings to localforage
            this.forage
                .setItem('users', users)
                .catch(error => console.info(`Could not save users: ${error.message}`))
        } else {
            console.info('Forage could not be found, was unable to update users')
        }
    }

    // Remove all users from localforage storage
    forgetAllUsers() {
        if (this.forage !== undefined) {
            this.forage
                .removeItem('users')
                .catch(error =>
                    console.info(
                        `Could not forget all users as localforage encountered an error: ${
                            error.message
                        }`,
                    ),
                )
        } else {
            console.info('Forage could not be found, was unable to remove all users.')
        }
    }

    // Read settings into state
    readUiSettingsIntoState(store) {
        if (this.forage !== undefined) {
            this.forage
                .getItem('ui-settings')
                .then((result) => {
                    if (result !== undefined && result !== null) {
                        store.dispatch(settingsActions.saveUiSettings(result))
                    } else {
                        store.dispatch(settingsActions.markAsLoaded())
                    }
                })
                .catch((error) => {
                    store.dispatch(settingsActions.markAsLoaded())
                    console.info(`Could not read ui settings from localforage: ${error.message}`)
                })
        } else {
            store.dispatch(settingsActions.markAsLoaded())
            console.info('Forage could not be found, unable to read ui settings')
        }
    }

    // Insert or update the ui settings in localforage storage
    setUISettings(uiSettings) {
        if (this.forage !== undefined) {
            // Save the new settings to localforage
            this.forage
                .setItem('ui-settings', uiSettings)
                .catch(error => console.info(`Could not save ui-settings: ${error.message}`))
        } else {
            console.info('Forage could not be found, was unable to update ui settings')
        }
    }

    readUsedSteamTicketIntoState(store) {
        if (this.forage !== undefined) {
            this.forage
                .getItem('steam-used-ticket')
                .then((result) => {
                    if (result !== undefined && result !== null) {
                        store.dispatch(steamActions.setUsedTicket(result))
                    }
                })
                .catch(error =>
                    console.info(
                        `Could not read used steam ticket from localforage: ${error.message}`,
                    ),
                )
        } else {
            console.info('Forage could not be found, unable to read used steam ticket')
        }
    }

    setUsedSteamTicket(ticket) {
        if (this.forage !== undefined) {
            this.forage
                .getItem('steam-used-ticket')
                .then(() => {
                    this.forage
                        .setItem('steam-used-ticket', ticket)
                        .catch(error =>
                            console.info(`Could not save steam-used-ticket:${error.message}`),
                        )
                })
                .catch(error => console.info(`Could not read steam-used-ticket: ${error.message}`))
        } else {
            console.info('Forage could not be found, was unable to update used Steam ticket')
        }
    }

    // Read settings into state
    readMotdIntoState(store) {
        if (this.forage !== undefined) {
            this.forage
                .getItem('motd')
                .then((result) => {
                    if (result !== undefined && result !== null) {
                        store.dispatch(toasterActions.setMessages(result.motds))
                    }
                })
                .catch(error =>
                    console.info(`Could not read motds from localforage: ${error.message}`),
                )
        } else {
            console.info('Forage could not be found, unable to read motd')
        }
    }

    // Set messages of the day in localforage storage
    setMotds(motds) {
        // If the forage is enabled, we can proceed
        if (this.forage !== undefined) {
            // Save the result in localforge
            this.forage
                .setItem('motd', motds)
                .catch(error => console.info(`Could not set motds to forage: ${error.message}`))
        } else {
            console.info('Forage could not be found, was unable to update motd')
        }
    }
}

window.localforage = forage



// WEBPACK FOOTER //
// ./src/store/localforage.js